import React, { useEffect, useRef, useState } from 'react';
import Logo from '../../../assets/svg/logo';
import Cart from '../../../assets/svg/cart';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa'
import { CgSearch } from "react-icons/cg";
import { RiArrowDownSLine } from "react-icons/ri";
import Iconlocation from '../../../assets/svg/location-icon';
import ProductImg from '../../../assets/svg/products_img';
import OutSideClick from '../../../utils/OutSideClick'
import { useDispatch, useSelector } from 'react-redux';
// import Clefill from "../../../assets/svg/RO3.png";
import Clefill from "../../../assets/svg/footer-logo-with-cap";
import {
    GET_CART_COUNT_LOCAL_ERROR, GET_CART_COUNT_LOCAL_SUCCESS, GET_CART_COUNT_SUCCESS, VALID_LOCATION_SUCCESS, ADD_CART_SUB_TOAL_SUCCESS,
    ADD_CART_TOTAL_SUCCESS,
} from '../../../constants/types';

import { checkLocation, createAcc, doLogout, getProfile, onSignIn, sendOTP, verifyOTP } from '../../../redux/actions/authAction';
import Close from '../../../assets/svg/close';
import BackArrow from '../../../assets/svg/backArrow';
import { MdOutlineNotificationsNone } from 'react-icons/md';
import { AiOutlineUser } from 'react-icons/ai';
import NumberFormat from 'react-number-format';
import swal from 'sweetalert';
import { addCartLocalToApi, getCart, getCartCount, productList, visitorCall, removeProductFromCart, updateProdQty,addToCart } from '../../../redux/actions/productAction';

import { Field, Form } from 'react-final-form';
import { renderInput, renderNumberInput } from '../../../utils/FormField';
import { SigninValidate, CreateAcc } from '../../../utils/validate';
import { createDeviceId, displayPhoneNumber, getDeviceType, pincodeFromLatLng, removeCountryCode, removeMobileFomrmatter, removeQuotsFun, toAbsoluteUrl } from '../../../utils';
import OtpInput from 'react-otp-input';
import LoaderBox from './Loader';
import axios from 'axios';
import { FiSearch, FiX, FiMapPin } from "react-icons/fi";
import banner1 from "../../../assets/images/slide11.avif";
import { ProgressBar, Step } from 'react-step-progress-bar';
import { FaCheck, FaLock } from 'react-icons/fa';
import { FaMinus, FaPlus, FaTrash, FaRegTrashAlt } from 'react-icons/fa';
import { addCartQty, priceFunction, productImagePath } from '../../../utils';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import WEmptyCart from "../../pages/cart/WEmptyCart";
import { getCartSuggestedProducts } from '../../../utils/getCartSuggestedProducts';


const Header = ({ signinModal, setsigninModal }) => {
    // console.log(signinModal)

    const dropDownRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const isValidLocation = useSelector(state => state.auth.isValidLocation)
    const cartCount = useSelector(state => state.product.cartCount)
    const cartCountLocal = useSelector(state => state.product.cartCountLocal)
    const profileData = useSelector(state => state.auth.userProfile?.profile)
    const userData = useSelector(state => state.auth.userData)
    const notificationCount = useSelector(state => state.userUtils.notificationCount)
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
    const authData = useSelector(state => state.auth)
    const allProductList = useSelector(state => state.product.productList)

    const [small, setSmall] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [showDropDown, setshowDropDown] = useState(false);
    const [otpModal, setotpModal] = useState(false);
    const [Timer, setTimer] = useState(0);
    const [signupModal, setsignupModal] = useState(false);
    const [locationModal, setLocationModal] = useState(false);
    const [otpData, setotpData] = useState({});
    const [suggestions, setSuggestions] = useState([]);

    // const [isAgreed, setisAgreed] = useState(false)

    const [otpValue, setotpValue] = useState('');
    const [click, setClick] = useState(false)
    const handleClick = () => setClick(!click)
    const deviceIp = JSON.parse(localStorage.getItem("deviceIp"));
    const sessionDeviceIp = JSON.parse(sessionStorage.getItem("deviceIp"));
    const [activeSearch, setActiveSearch] = useState(false)
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [cartModel, setCartModel] = useState(false);
    const cartUniqueProductCount = useSelector(state => state.product.cartUniqueProductCount)
    const apiCartData = useSelector((state) => state.product.cart);
    const localCartData = JSON.parse(localStorage.getItem("cart"));
    let city = authData?.validLocation ? authData?.validLocation.replace(/^\d+\s/, "") : null

    const {
        subscriptionCartDiscount = 0,
    } = useSelector((state) => state.userUtils.subscriptionValue || {});

    const productReducer = useSelector((state) => state.product);
    const [localCartInfoState, setlocalCartInfoState] = useState([]);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const cartItems = isLoggedIn ? apiCartData?.length == 0 ? [] : apiCartData : localCartInfoState?.length == 0 ? [] : localCartInfoState;
    const suggestionitems = getCartSuggestedProducts(allProductList, cartItems, 6);
    


    const [keyword, setKeyword] = React.useState('')
    const [youSaved, setyouSaved] = useState(0);

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", () =>
                setSmall(window.pageYOffset > 0)
            );
        }
    }, []);

    useEffect(() => {
        setKeyword("")
        setSuggestions([])
    }, [window.location.pathname]);

    // Set countdown for otp modal
    useEffect(() => {
        setTimeout(() => {
            if (Timer > 0 && otpModal) {
                setTimer(Timer - 1)
            }
        }, 1000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Timer, otpModal])
    // Header dropdown outside click Fun
    OutSideClick(dropDownRef, () => {
        if (showDropDown) { setshowDropDown(false); }
    });
    // Fun to get cart data for loggedin and non loggedin also fetch cart total and profile api
    useEffect(() => {
        // if (authData?.isValidLocation) {
        //     dispatch(getNameFrmPincode(authData?.validLocation))
        // }
        if (isLoggedIn) {
            dispatch(getCartCount({ customerId: userData?.id }))
            dispatch(getProfile())
        }
        else {
            if (JSON.parse(localStorage.getItem('cartTotal'))) {
                let length = JSON.parse(localStorage.getItem('cartTotal'))
                dispatch({
                    type: GET_CART_COUNT_LOCAL_SUCCESS, payload: length
                })
            }
            else {
                dispatch({
                    type: GET_CART_COUNT_LOCAL_ERROR, payload: 0
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])
    // Logout function
    const onLogout = () => {

        const fcmToken = JSON.parse(localStorage.getItem("FCMToken"));
        dispatch(doLogout({ fcmToken: fcmToken ? fcmToken : ' ' }))

        dispatch({ type: GET_CART_COUNT_SUCCESS, payload: 0 })
        if (localStorage.getItem('cart')) {
            localStorage.removeItem('cart')
        }
        if (localStorage.getItem('cartTotal')) {
            localStorage.removeItem('cartTotal')
        }
    };

    const handleVisitorCall = () => {
        if (!sessionDeviceIp && deviceIp) {
            dispatch(
                visitorCall({
                    ipAddress: deviceIp,
                })
            );
            sessionStorage.setItem("deviceIp", JSON.stringify(deviceIp));
        }
    }
    //For Location pop up detect location api
    const onDetectLocation = (manualPinCode, type) => {

        let tmpIp = JSON.parse(localStorage.getItem("deviceIp"));
        let tmpObj = { ipAddress: tmpIp, customerId: userData?.id ? userData?.id : '' }

        if (type === 'manual') {
            let manualData = { pincode: manualPinCode, ...tmpObj }
            setisLoading(true)
            dispatch(checkLocation(manualData))
                .then(res => {
                    setisLoading(false)
                    setLocationModal(false)
                    axios.defaults.headers.common["pincode"] = res.data?.pincode
                    localStorage.setItem('pincode', res.data?.pincode)
                    handleVisitorCall()
                    localStorage.setItem('validLocation', JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city))
                    setTimeout(() => {
                        dispatch({ type: VALID_LOCATION_SUCCESS, payload: JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city) })
                    }, 1000);
                    dispatch(productList({
                        page: 1,
                        limit: 100,
                        customerId: '',
                        productType: ""
                    }))
                })
                .catch(err => {
                    setisLoading(false)
                    swal('', err.message, 'error')
                })
        }
        else {
            //success function
            setisLoading(true)
            navigator.geolocation.getCurrentPosition((pos) => {
                var crd = pos.coords

                pincodeFromLatLng(crd.latitude, crd.longitude)
                    .then(pincodeRes => {
                        dispatch(checkLocation({ pincode: pincodeRes, ...tmpObj }))
                            .then(res => {
                                setisLoading(false)
                                setLocationModal(false)
                                axios.defaults.headers.common["pincode"] = res.data?.pincode
                                localStorage.setItem('pincode', res.data?.pincode)
                                handleVisitorCall()
                                localStorage.setItem('validLocation', JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city))
                                setTimeout(() => {
                                    dispatch({ type: VALID_LOCATION_SUCCESS, payload: JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city) })
                                }, 1000);
                                dispatch(productList({
                                    page: 1,
                                    limit: 100,
                                    customerId: '',
                                    productType: ""
                                }))
                            })
                            .catch(err => {
                                setisLoading(false)
                                swal(`Detected pincode : ${pincodeRes}`, err.message, 'error')
                            })
                    })
                    .catch(err => {
                        setisLoading(false)
                        console.log('err: ', err);
                    })

            }, (err) => {
                // error function
                setisLoading(false)
                // console.log('err: ', err);
                if (err?.message) {
                    if (err?.code === 1)
                        swal('Location Permission Required', 'Please allow location permission !', 'error')
                    else if (err?.code === 2)
                        swal('Position unavailable !', 'Please try again or try by adding pincode manually !', 'error')
                    else if (err?.code === 3)
                        swal('Timed Out !', 'Please try again or try by adding pincode manually !', 'error')
                    else {
                        swal('', err?.message, 'error')
                    }
                }
                else {
                    alert('something went wrong')
                }
            }, {
                enableHighAccuracy: true,

                timeout: 5000,
                maximumAge: 0
            });
        }
    };
    // On Signup Submit 
    const onSignUpSubmit = (data, form) => {
        dispatch(sendOTP({ phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'register' }))
            .then(res => {
                setotpData({ ...data, phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'register' })
                setsignupModal(false)
                setTimer(60)
                setotpModal(true)
                // setisAgreed(false)
                form?.restart()
            })
            .catch(err => {
                swal('', err.message, 'error')
                // resetOtpData()
            })
    };
    // On signin Submit
    const onSignInSubmit = (data, form) => {
        dispatch(sendOTP({ phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'login' }))
            .then(res => {
                setotpData({ ...data, phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'login' })
                setsigninModal(false)
                setTimer(60)
                setotpModal(true)
                form?.restart()
            })
            .catch(err => {
                form?.restart()
                setsigninModal(false)
                setotpData({ ...otpData, phoneNumber: removeMobileFomrmatter(data.phoneNumber) })
                setsignupModal(true)
                setTimer(60)
                // swal('', err.message, 'error')
                // resetOtpData()
            })
    };
    // Set otp value to local state
    const onOtpChange = (otp) => {
        setotpValue(otp)
    };
    // Reset otp data on modal close
    const resetOtpData = () => {
        setotpValue('')
        setotpData({})
        setTimer(0)
    };
    // Handle Otp submit method for signin and signup
    const handleOtpSubmit = (e) => {
        e.preventDefault();
        let ipAddress = JSON.parse(localStorage.getItem("deviceIp"));
        const FCMtoken = JSON.parse(localStorage.getItem('FCMToken'))
        const pincode = JSON.parse(localStorage.getItem("validLocation"));

        let pincodeLocal = '';
        if (pincode) {
            let tmpVar = pincode?.split(" ")
            if (tmpVar)
                pincodeLocal = tmpVar[0]
        }


        dispatch(verifyOTP({ otp: otpValue, phoneNumber: removeMobileFomrmatter(otpData.phoneNumber) }))
            .then(res => {
                if (otpData?.type === 'register') {
                    dispatch(createAcc({ ...otpData, phoneNumber: removeMobileFomrmatter(otpData.phoneNumber), fcmToken: FCMtoken ? FCMtoken : '123455', deviceId: createDeviceId(), deviceType: getDeviceType(), ipAddress: ipAddress || '', pincode: pincodeLocal || '' }))
                        .then(res => {
                            resetOtpData()
                            setotpModal(false)
                            setsignupModal(false)
                            dispatch(getProfile())

                            const localCartData = JSON.parse(localStorage.getItem('cart'))

                            // If local cart has any data then will be added to user cart api
                            if (localCartData && localCartData?.length) {
                                dispatch(addCartLocalToApi({ customerId: res?.data?.id, products: [...localCartData] }))
                                    .then(res2 => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                        if (localStorage.getItem('cart')) {
                                            localStorage.removeItem('cart')
                                        }
                                        if (localStorage.getItem('cartTotal')) {
                                            localStorage.removeItem('cartTotal')
                                        }
                                    })
                                    .catch(Err => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                    })
                            }
                            // If local cart has no cart data then will not be added to api
                            else {
                                dispatch(getCart({ customerId: res?.data?.id }))
                                dispatch(getCartCount({ customerId: res?.data?.id }))
                            }
                        })
                        .catch(err => {
                            swal('', err?.message, 'error')
                        })
                }
                else {
                    dispatch(onSignIn({ ...otpData, phoneNumber: removeMobileFomrmatter(otpData.phoneNumber), deviceType: getDeviceType(), deviceId: createDeviceId(), fcmToken: FCMtoken ? FCMtoken : '123455', ipAddress: ipAddress || '', pincode: pincodeLocal || '' }))
                        .then(res => {
                            resetOtpData()
                            setotpModal(false)
                            setsigninModal(false)
                            dispatch(getProfile())

                            const localCartData = JSON.parse(localStorage.getItem('cart'))

                            // If local cart has any data then will be added to user cart api
                            if (localCartData && localCartData?.length) {
                                dispatch(addCartLocalToApi({ customerId: res?.data?.id, products: [...localCartData] }))
                                    .then(res2 => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                    })
                                    .catch(Err => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                    })
                            }
                            // If local cart has no cart data then will not be added to api
                            else {
                                dispatch(getCart({ customerId: res?.data?.id }))
                                dispatch(getCartCount({ customerId: res?.data?.id }))
                            }
                        })
                        .catch(err => {
                            console.log('err: ', err);
                            // swal('', err?.message, 'error')
                            // if (err?.message) {
                            //     swal('', err?.message + 'signin', 'error')
                            // }
                        })
                }
            })
            .catch(err => {
                swal('', err.message, 'error')
                // swal('', err?.message + 'outside', 'error')
            })
    };
    // On Resend OTP
    const onResendOtp = () => {
        // setisLoading(true)
        dispatch(sendOTP({ phoneNumber: removeMobileFomrmatter(otpData?.phoneNumber), type: otpData?.type }))
            .then(res => {
                setTimer(60)
                // setisLoading(false)
                swal('', res.message, 'success')
            })
            .catch(err => {
                setTimer(60)
                // setisLoading(false)
                swal('', err.message, 'error')
            })
    };

    const handleRedirect = (path) => {
        if (!isValidLocation) {
            setLocationModal(true)
        } else {
            history.push(path)
        }
    }

    const handleInputChange = (e) => {
        e.preventDefault();
        if (isValidLocation) {
            const value = e.target.value;
            setKeyword(value);

            if (value?.trim().length > 0) {
                const filteredNames = allProductList
                    .filter(item =>
                        item?.productName?.trim().toLowerCase().includes(value.trim().toLowerCase())
                    )
                    .splice(0, 5);

                setSuggestions(filteredNames);
            } else {
                setSuggestions([]);
            }
        } else {
            setLocationModal(true);
        }
    };

    const steps = [
        { label: 'GET 5%', subLabel: 'Buy 3' },
        { label: 'GET 10%', subLabel: 'Buy 4' },
        { label: 'GET 15%', subLabel: 'Buy 5' },
    ];
    const thresholds = steps.map(s => parseInt(s.subLabel.replace(/\D/g, '')));
    const stepPercent = 100 / (steps.length - 1);

    let accomplished = thresholds.filter(qty => cartUniqueProductCount >= qty).length;

    let percent = 0;
    if (accomplished === steps.length) {
        percent = 100;
    } else if (accomplished > 0) {
        const prev = thresholds[accomplished - 1];
        const next = thresholds[accomplished];
        const range = next - prev;
        const progress = cartUniqueProductCount - prev;
        percent = (accomplished - 1) * stepPercent + (progress / range) * stepPercent;
    }



    const onProductQtyChange = (customerId, cartId, sid, qty, pid) => {

        if (!isLoggedIn) {
            let oldArray = [];
            if (localStorage.getItem('cart')) {
                oldArray = JSON.parse(localStorage.getItem('cart'));
            }
            if (qty > 0) {
                oldArray = oldArray.map((val, i) => {
                    // eslint-disable-next-line eqeqeq
                    if (val.productId == pid && val.skuId == sid) {
                        return { ...val, quantity: qty }
                    }
                    else {
                        return val
                    }
                })
            }
            else {
                oldArray = oldArray?.filter((val, i) => {
                    // eslint-disable-next-line eqeqeq
                    return !(val.productId == pid && val.skuId == sid)
                })

            }
            setTimeout(() => {
                addCartQty()
            }, 200);
            localStorage.setItem('cart', JSON.stringify(oldArray));
            setTrigger(Math.random())
        }
        else {
            // setIsLoading(true)
            dispatch(updateProdQty({ cartId: cartId, quantity: qty, customerId: customerId }))
                .then(res => {
                    dispatch(getCart({ customerId: customerId, city: city, subscriptionDiscount: subscriptionCartDiscount }))
                    dispatch(getCartCount({ customerId: customerId }))
                    // setIsLoading(false)
                })
                .catch(err => {
                    swal("", err.message, "error")
                    // setIsLoading(false)
                })
            // dispatch(productList(args))
        }
    };

    // const suggestedProducts = [
    //     {
    //         id: 1,
    //         name: 'Clefill Glass Cleaner',
    //         subtitle: 'The Ultimate Shine Enhancer!',
    //         image: banner1,
    //         skus: [
    //             { label: '500ml', price: 89 },
    //             { label: '1L', price: 159 },
    //             { label: '2L', price: 299 }
    //         ]
    //     },
    //     {
    //         id: 2,
    //         name: 'Clefill Floor Cleaner',
    //         subtitle: 'Kills 99.9% Germs',
    //         image: banner1,
    //         skus: [
    //             { label: '500ml', price: 79 },
    //             { label: '1L', price: 139 },
    //             { label: '2L', price: 259 }
    //         ]
    //     },
    //     {
    //         id: 3,
    //         name: 'Clefill Bathroom Cleaner',
    //         subtitle: 'Deep Cleaning Formula',
    //         image: banner1,
    //         skus: [
    //             { label: '500ml', price: 99 },
    //             { label: '1L', price: 149 },
    //             { label: '2L', price: 269 }
    //         ]
    //     }
    // ];


    const [selectedSkus, setSelectedSkus] = useState({});

    const handleSkuChange = (productId, skuId) => {
        setSelectedSkus({
          [productId]: skuId     // store sku per product
        });
      };
      const onAddToCartClick = (sid, qty, pid) => {
        // console.log("cat2", { productId: pid, skuId: sid, quantity: qty, customerId: userData.id })
        if (!selectedSkus) {
            // console.log("ca3", { productId: pid, skuId: sid, quantity: qty, customerId: userData.id })
            swal('', "Please select one variant", "error")
        }
        else {
            
                // console.log("cat", { productId: pid, skuId: sid, quantity: qty, customerId: userData.id })
                dispatch(addToCart({ productId: pid, skuId: sid, quantity: qty, customerId: userData.id }))
                    .then(res => {
                        // setselectedSkuExist(true)
                        dispatch(getCart({ customerId: userData.id }))
                        dispatch(getCartCount({ customerId: userData.id }))
                    })
                    .catch(err => {
                        swal("", err.message, "error")
                    })
            
        }

    };

    useEffect(() => {
        if (localCartInfoState) setlocalCartInfoState(localCartData);
        else setlocalCartInfoState([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger, cartCountLocal]);

    useEffect(() => {
        let localCartdata2 = JSON.parse(localStorage.getItem("cart"));

        if (!isLoggedIn && localCartdata2 && localCartdata2.length) {
            let totalPrice = 0;
            let totalYouSaved = 0;
            localCartdata2.map((val) => {
                totalPrice =
                    Number(totalPrice) +
                    Number(val?.quantity) * Number(val?.sku?.salePrice);
                totalYouSaved =
                    Number(totalYouSaved) +
                    (Number(val?.sku?.productPrice) - Number(val?.sku?.salePrice)) *
                    val?.quantity;
                return null;
            });
            setyouSaved(totalYouSaved);
            dispatch({ type: ADD_CART_TOTAL_SUCCESS, payload: totalPrice });
            dispatch({ type: ADD_CART_SUB_TOAL_SUCCESS, payload: totalPrice });
        } else if (isLoggedIn && apiCartData?.length) {
            let totalYouSaved = 0;
            // let totalDicount = 0;
            apiCartData?.map((val) => {
                totalYouSaved =
                    Number(totalYouSaved) +
                    (Number(val?.sku?.productPrice) - Number(val?.sku?.salePrice)) *
                    val?.quantity;
                return null;
            });
            setyouSaved(totalYouSaved);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger, isLoggedIn, localCartInfoState]);


    return (
        <>
            {isLoading && <LoaderBox />}
            <header className={`mheader-bar wheader-bar scroll-header ${small ? "" : ""}`}>
                <div className="top-bar">
                    <div className="container d-flex justify-content-between align-items-center py-1 px-3">
                        <span className="shipping-text">Doorstep Delivery in 24 hours</span>
                        {/* <div className="pincode-box d-flex align-items-center">
                            <i ><Iconlocation /></i>
                            <input
                                type="text"
                                placeholder="Enter your pincode"
                                className="pincode-input"
                                onClick={(e) => setLocationModal(true)}
                            />
                        </div> */}
                        <div className="location-box">
                            <i><Iconlocation /></i>
                            <p>
                                {authData?.isValidLocation ? removeQuotsFun(authData?.validLocation) : ' No Location '}
                                <Link to="#" onClick={(e) => { e.preventDefault(); setLocationModal(true) }}>
                                    &nbsp;{`Change`}
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='cls-top-hader'>
                    <div className="container">
                        <div className="row">
                            <div className="d-flex flex-wrap align-items-center w-100 justify-content-between">
                                {/* Left Box - Location */}
                                <div className="left-box">
                                    <div className="top-nav-links d-flex align-items-center">
                                        <Link to="/product_list/prefill/all" className="top-link">Shop All</Link>
                                        {/* <Link to="/bundle_save" className="top-link">Bundle & Save</Link> */}
                                        <Link to="/subscribe_and_save" className="top-link">Subscribe & Save</Link>
                                    </div>
                                    {/* <div className="location-box">
                                        <i><Iconlocation /></i>
                                        <p>
                                            {authData?.isValidLocation ? removeQuotsFun(authData?.validLocation) : ' No Location '}
                                            <Link to="#" onClick={(e) => { e.preventDefault(); setLocationModal(true) }}>
                                                &nbsp;{`Change`}
                                            </Link>
                                        </p>
                                    </div> */}
                                </div>

                                {/* Center Box - Logo */}
                                <div className="logo-box">
                                    <Link to="/">
                                        <i> <Clefill /> </i>
                                        {/* <img src={Clefill} height="36" width="250" alt="product-img" /> */}
                                    </Link>
                                </div>
                                <div className="right-box">

                                    {/* {isLoggedIn && <i onClick={(e) => { e.preventDefault(); history.push('/notifications') }} className={`${notificationCount > 0 ? 'green-dots' : ''}`} style={{
                                        alignItems: 'center',
                                        height: '80%', // or a specific height like '40px'
                                    }}> <MdOutlineNotificationsNone color="black" /> </i>} */}
                                    <div className="top-nav-links d-flex align-items-center">
                                        <Link to="/about_clefill" className="top-link">About Us</Link>
                                        {/* <Link to="/bundle_save" className="top-link">FAQs</Link> */}
                                        <Link to="/contactus" className="top-link">Contact Us</Link>
                                    </div>

                                    <i onClick={() => setIsSearchOpen(true)}> <CgSearch style={{ fontSize: '22px', cursor: 'pointer', color: 'black', marginRight: "20px" }} /> </i>
                                    <div className="link-box">
                                        {<i className="users" onClick={() => { setshowDropDown(!showDropDown) }}> <AiOutlineUser color="black" /> </i>}
                                        
                                    </div>

                                    <div className={`drop-down ${showDropDown ? 'active' : ''}`} ref={dropDownRef}>
                                        <ul className="drop-downlist">
                                            {/* {isLoggedIn && <li className="bottom-line"> <NavLink to="/" onClick={(e) => { e.preventDefault() }} className="user" >Hello {profileData.firstName} {profileData.lastName}</NavLink> </li>}
                                        <li> <NavLink to="/" onClick={(e) => { e.preventDefault(); setLocationModal(true) }} className="loction-icon"> {authData?.isValidLocation ? authData?.validLocation : 'No Location '} {` change`} </NavLink> </li> */}
                                            {!isLoggedIn &&
                                                <>
                                                    <li> <NavLink to="/" onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!isValidLocation) {
                                                            setLocationModal(true)
                                                        }
                                                        else {
                                                            setsigninModal(true)
                                                        }
                                                    }}> Sign in </NavLink> </li>
                                                    <li> <NavLink to="/" onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!isValidLocation) {
                                                            setLocationModal(true)
                                                        }
                                                        else {
                                                            setsigninModal(true)
                                                        }
                                                    }}> Register</NavLink> </li>
                                                </>
                                            }
                                            {isLoggedIn &&
                                                <>
                                                    <li> <NavLink to="/account_dashboard/profile" onClick={(e) => { setshowDropDown(false) }}> My Profile </NavLink> </li>
                                                    {/* <li> <NavLink to="/account_dashboard/payment" onClick={(e) => { setshowDropDown(false) }}> My Payment </NavLink> </li> */}
                                                    <li> <NavLink to="/account_dashboard/promo_codes" onClick={(e) => { setshowDropDown(false) }}> My Promo Code </NavLink> </li>
                                                    <li> <NavLink to="/account_dashboard/my_subscription" onClick={(e) => { setshowDropDown(false) }}> My Subscription </NavLink> </li>
                                                    <li className="bottom-line"> <NavLink to="/account_dashboard/referral_codes" onClick={(e) => { setshowDropDown(false) }}> Refer & Save! </NavLink> </li>
                                                    <li> <NavLink to="/account_dashboard/my_reviews" onClick={(e) => { setshowDropDown(false) }}>My Review</NavLink> </li>
                                                    <li> <NavLink to="/account_dashboard/order_list" onClick={(e) => { setshowDropDown(false) }}> My Orders </NavLink> </li>
                                                    <li> <NavLink to="/account_dashboard/help_center" onClick={(e) => { setshowDropDown(false) }}> Help Center </NavLink> </li>
                                                </>
                                            }
                                            {isLoggedIn && <li> <NavLink to="/" onClick={() => onLogout()}> Log out </NavLink> </li>}
                                        </ul>
                                    </div>
                                    {/* <i onClick={(e) => { e.preventDefault(); history.push('/notifications') }} className="green-dots"> <Notification /> </i> */}
                                    <i onClick={(e) => {
                                        e.preventDefault();
                                        if (isValidLocation) {
                                            if (isLoggedIn) {
                                                // history.push('/cart')
                                                setCartModel(true)
                                            } else {
                                                setsigninModal(true)
                                            }



                                        }
                                        else
                                            setLocationModal(true)
                                    }} className="cart"> <Cart />  {isLoggedIn ? (cartCount > 0 && <span> {cartCount} </span>) : (cartCountLocal > 0 && <span> {cartCountLocal} </span>)}  {/*<b>5000</b>*/}  </i>

                                </div >
                            </div >
                        </div >
                    </div>
                </div>
                {
                    // (history?.location?.pathname === '/' || history?.location?.pathname === "/about_clefill") &&
                    <div className='cls-bootam-hader'>
                        {/* <div className="container"> */}

                        <div className='row align-items-center'>
                            <div className='col-12'>
                                <div className='hamburger' onClick={handleClick}>
                                    {click ? (<FaTimes size={20} style={{ color: '#333' }} />) : (<FaBars size={20} style={{ color: '#333' }} />)}
                                </div>
                                <div className='menu-main'>
                                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/refill/all")
                                                }}
                                            >Refills</a>

                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/dish-wash-gel")
                                                }}
                                            >Dishwash Gel</a>
                                            {/* <div className="mega-menu"> */}
                                            {/* <ul>
                                                    <li><a href="#">Subitem 1</a></li>
                                                    <li><a href="#">Subitem 2</a></li>
                                                    <li><a href="#">Subitem 3</a></li>
                                                </ul> */}
                                            {/* </div> */}
                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/laundry-care")
                                                    // history.push("/product_list/prefill/laundry-care")
                                                }}
                                            >Liquid Detergents</a>

                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/floor-cleaner")
                                                }}
                                            >Floor Cleaners</a>

                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/glass-cleaner-")
                                                }}
                                            >Glass Cleaners</a>

                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/toilet-cleaner")
                                                }}
                                            >Toilet Cleaners</a>

                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/bathroom-cleaner")
                                                }}
                                            >Bathroom Cleaners</a>

                                        </li>
                                        <li className='cls-dropdown-nav'>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/product_list/prefill/hand-wash")
                                                }}
                                            >Hand Wash</a>

                                        </li>
                                        <li>
                                            <a className='nav-item'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleRedirect("/about_clefill")
                                                }}
                                            >Our Story</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div >
                    // </div>
                }
                {/* Search Option */}
                {isSearchOpen && (
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder="search..."
                            value={keyword}
                            onChange={handleInputChange}
                            className="search-input"
                        />
                        <FiX onClick={() => { setIsSearchOpen(false); setKeyword("") }} className="icon close-icon" />
                    </div>
                )}

                {keyword && suggestions.length > 0 && (
                    <div className="search-dropdown">
                        {suggestions.map((item, index) => (
                            <div key={index} className="search-item"
                                onClick={() => {
                                    history.push(`/product_detail/${item?.productcategory.category.toLowerCase()}/${item?.productName.replace(/\s+/g, '-')}`);
                                    setIsSearchOpen(false);
                                    // setKeyword("")};
                                }
                                }
                            >
                                {item.productName}
                            </div>
                        ))}
                    </div>
                )}
            </header >

            

            {otpModal &&
                <div className="otp-modal-overlay">
                    <div className="otp-modal-container">
                        <div className="otp-modal-left">
                            <img
                                src={banner1} // Replace with your actual image
                                alt="Product"
                                className="product-image"
                            />
                        </div>
                        <div className="otp-modal-right">
                            <button
                                className="close-button"
                                onClick={() => {
                                    setotpModal(false);
                                    resetOtpData();
                                }}
                            >
                                <Close />
                            </button>

                            <div
                                className="back-arrow"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setotpModal(false);
                                    setotpValue("");
                                    if (otpData?.type === "register") {
                                        setsignupModal(true);
                                    } else {
                                        setsigninModal(true);
                                    }
                                }}
                            >
                                <BackArrow />
                            </div>

                            <h2 className="otp-title">OTP</h2>

                            <p className="otp-instruction">
                                Please enter Verification code sent to <br />
                                <strong>
                                    +91 {displayPhoneNumber(removeCountryCode(otpData?.phoneNumber))}
                                </strong>{" "}
                                <Link
                                    to="/"
                                    className="change-link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setotpValue("");
                                        setotpModal(false);
                                        if (otpData?.type === "register") {
                                            setsignupModal(true);
                                        } else {
                                            setsigninModal(true);
                                        }
                                    }}
                                >
                                    or Change phone number
                                </Link>
                            </p>

                            <div className="otp-inputs">
                                <OtpInput
                                    value={otpValue}
                                    onChange={onOtpChange}
                                    isInputNum={true}
                                    numInputs={6}
                                    shouldAutoFocus={true}
                                    inputStyle="otp-box" // this still works
                                    containerStyle="otp-inputs"
                                    separator={<span></span>}
                                />
                            </div>

                            {Timer >= 1 && (
                                <p className="resend-text">Resend in {Timer} seconds</p>
                            )}
                            {Timer < 1 && (
                                <button type="button" onClick={onResendOtp} className="links-btn">
                                    Resend OTP
                                </button>
                            )}
                            {otpValue.length === 6 && (
                                <button
                                    type="submit"
                                    onClick={handleOtpSubmit}
                                    className="links-btn"
                                >
                                    Submit
                                </button>
                            )}
                        </div>
                    </div>
                </div>}

            {/* location Modal */}
            {locationModal && (
                <div className="modal-backdrop">
                    <div className="modal-box">
                        <button className="modal-close" onClick={() => setLocationModal(false)}>
                            <FiX size={20} />
                        </button>
                        <h2 className="modal-title">
                            where should we <br />
                            <span className="gradient-text">deliver the products?</span>
                        </h2>
                        <p className="modal-subtext">Enter location to explore products in your area</p>

                        <div className="pincode-input-wrapper">
                            <FiMapPin className="input-icon" />
                            <input type="text" placeholder="Type your Pincode..."
                                maxLength={6}
                                pattern="\d{6}"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val.length === 6) onDetectLocation(val, "manual");
                                }} />
                        </div>

                        <div className="or-text">or</div>

                        <button className="detect-btn" onClick={() => onDetectLocation(false, 'auto')}>DETECT MY LOCATION</button>
                    </div>
                </div>
            )}

            
            {signupModal &&
                <div className="modal-overlay-signup">
                    <div className="signup-modal">
                        <div className="modal-left">
                            <img
                                src={banner1} // Replace with your actual image
                                alt="Product"
                                className="product-image"
                            />
                        </div>
                        <div className="modal-right">
                            <Form
                                initialValues={
                                    otpData ? { ...otpData, phoneNumber: removeCountryCode(otpData?.phoneNumber) } : {}
                                }
                                onSubmit={(value, formProps) => onSignUpSubmit(value, formProps)}
                                validate={CreateAcc}
                            >
                                {({ handleSubmit, form }) => (
                                    <form className="form" onSubmit={handleSubmit}>
                                        <button
                                            className="close-button"
                                            type="button"
                                            onClick={() => {
                                                setsignupModal(false);
                                                form.restart();
                                                resetOtpData();
                                            }}
                                        >
                                            <Close />
                                        </button>

                                        <h2>
                                            getting <span className="logged-in-text">started</span>
                                        </h2>
                                        <p className="subheading">Create a account to continue</p>

                                        <div className="form-group">
                                            <span className="icon">📞</span>
                                            <Field name="phoneNumber">
                                                {({ input, meta }) => (
                                                    <>
                                                        <div className="input-with-prefix">
                                                            <span className="prefix">+91</span>
                                                            <input
                                                                {...input}
                                                                type="tel"
                                                                placeholder="Enter your 10 digit mobile number"
                                                            //   className={`floating__input ${meta.touched && meta.error ? "input-error" : ""}`}
                                                            />
                                                        </div>
                                                        {meta.touched && meta.error && (
                                                            <div className="error-text">{meta.error}</div>
                                                        )}
                                                    </>
                                                )}
                                            </Field>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-group">
                                                <span className="icon">👤</span>
                                                <Field name="firstName">
                                                    {({ input, meta }) => (
                                                        <>
                                                            <input
                                                                {...input}
                                                                type="text"
                                                                placeholder="First Name"
                                                                className={`floating__input ${meta.touched && meta.error ? "input-error" : ""}`}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error-text">{meta.error}</div>
                                                            )}
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="form-group">
                                                <span className="icon">👤</span>
                                                <Field name="lastName">
                                                    {({ input, meta }) => (
                                                        <>
                                                            <input
                                                                {...input}
                                                                type="text"
                                                                placeholder="Last Name"
                                                                className={`floating__input ${meta.touched && meta.error ? "input-error" : ""}`}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error-text">{meta.error}</div>
                                                            )}
                                                        </>
                                                    )}
                                                </Field>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <span className="icon">✉️</span>
                                            <Field name="email">
                                                {({ input, meta }) => (
                                                    <>
                                                        <input
                                                            {...input}
                                                            type="email"
                                                            placeholder="Email Address (optional)"
                                                            className={`floating__input ${meta.touched && meta.error ? "input-error" : ""}`}
                                                        />
                                                        {meta.touched && meta.error && (
                                                            <div className="error-text">{meta.error}</div>
                                                        )}
                                                    </>
                                                )}
                                            </Field>
                                        </div>

                                        <button type="submit" className="submit-btn">
                                            SIGN UP
                                        </button>
                                    </form>
                                )}
                            </Form>
                        </div>
                    </div>
                </div>
            }

            

            {signinModal && (
                <div className="modal-overlay-login">
                    <div className="login-modal">
                        <Form
                            initialValues={otpData ? { ...otpData, phoneNumber: '' } : {}}
                            onSubmit={(value, formProps) => {
                                onSignInSubmit(value, formProps);
                            }}
                            validate={SigninValidate}
                        >
                            {({ handleSubmit, form }) => (
                                <form onSubmit={handleSubmit}>
                                    <button
                                        className="close-button"
                                        onClick={() => {
                                            setsigninModal(false);
                                            form.restart();
                                            resetOtpData();
                                        }}
                                        type="button"
                                    >
                                        <Close />
                                    </button>
                                    <div className="login-modal-content">
                                        <div className="login-image">
                                            <img src={banner1} alt="Product" />
                                        </div>
                                        <div className="login-form">
                                            <h2>
                                                Let’s get you <span className="logged-in-text">logged in</span>
                                            </h2>
                                            <p>If you have an account sign in with Registered phone number.</p>

                                            <Field name="phoneNumber">
                                                {({ input, meta }) => (
                                                    <>
                                                        <div className="input-container">

                                                            <div className="input-wrapper">
                                                                <span className="phone-icon">📞</span>
                                                                <span className="phone-prefix">+91</span>
                                                                <input
                                                                    {...input}
                                                                    type="tel"
                                                                    placeholder="Enter your 10 digit mobile number"
                                                                    className={`floating__input`}
                                                                />
                                                            </div>
                                                            <div className="error-container">
                                                                {meta.touched && meta.error && (
                                                                    <div className="error-text">{meta.error}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </Field>

                                            <button type="submit" className="continue-button">
                                                CONTINUE
                                            </button>
                                            <div className="terms-text">
                                                By continuing, you agree to our{" "}
                                                <a href={toAbsoluteUrl(`/cms/tc`)} target="_blank" rel="noreferrer">
                                                    Terms
                                                </a>
                                                ,{" "}
                                                <a href={toAbsoluteUrl(`/cms/rrd`)} target="_blank" rel="noreferrer">
                                                    Refunds
                                                </a>{" "}
                                                and{" "}
                                                <a href={toAbsoluteUrl(`/cms/tc`)} target="_blank" rel="noreferrer">
                                                    Privacy Policy
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Form>
                    </div>
                </div>
            )}

            {cartModel && (
                <div className="cart-sidebar">
                    <div className="cart-top-fixed">
                        <div className="cart-header">
                            <h2 className="cart-title">
                                Your Bag <span className="cart-count">({isLoggedIn ? (cartCount > 0 ? cartCount : 0) : (cartCountLocal > 0 ? cartCountLocal : 0)})</span>
                            </h2>
                            <button className="close-button" onClick={() => { setCartModel(false) }}>×</button>
                        </div>

                        <div className="discount-banner">
                            <span className="star-icon">✦</span>
                            <span className="discount-text">
                                UNLOCK DISCOUNTS WHEN YOU SHOP ACROSS CATEGORIES
                            </span>
                            <span className="star-icon">✦</span>
                        </div>
                        {/* <div className="web-cart-discount-container">
                            <ProgressBar
                                percent={percent}
                                filledBackground="#c0002e"
                                height={8}
                            >
                                {steps.map((step, index) => {
                                    const requiredQty = parseInt(step.subLabel.replace(/\D/g, ''));
                                    const isAccomplished = cartUniqueProductCount >= requiredQty;
                                    return (
                                        <Step key={index}>
                                            {({ accomplished }) => (
                                                <div className="step-group">
                                                    <div className={`step-icon ${isAccomplished ? 'done' : 'pending'}`}>
                                                        {isAccomplished ? <FaCheck size={10} color="#fff" /> : <FaLock size={10} />}
                                                    </div>
                                                    <div className="step-label">
                                                        <div className="label-main">{step.label}</div>
                                                        <div className="label-sub">{step.subLabel}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </Step>
                                    )
                                })}
                            </ProgressBar>
                        </div> */}
                    </div>
                    {
                        (isLoggedIn && apiCartData.length === 0) ||
                            (!isLoggedIn && (!localCartInfoState || localCartInfoState.length === 0)) ? (
                            <WEmptyCart />
                        ) : (
                            <div className="mini-cart-container">
                                {(isLoggedIn ? apiCartData : localCartInfoState)?.map((item) => (
                                    <div key={item.id} className="cart-item">
                                        <img src={productImagePath(item?.product?.productMainImage)} alt={item?.product?.productMainImage} className="item-image" />

                                        <div className="item-info">
                                            <h3>{item?.product?.productName}</h3>
                                            <p>SKU: {item?.sku?.skuName}</p>
                                            <p>Category: {item?.product?.productcategory?.category}</p>
                                            <div className="quantity-wrapper">
                                                <button onClick={(e) => { e.preventDefault(); onProductQtyChange(item.customerId, item.id, item?.sku?.id, Number(item.quantity) - 1, item?.product?.id) }}>{item.quantity > 1 ? <FaMinus size={12} /> : <FaTrash size={12} />}</button>
                                                <span>{item.quantity}</span>
                                                <button onClick={(e) => { e.preventDefault(); onProductQtyChange(item.customerId, item.id, item?.sku?.id, Number(item.quantity) + 1, item?.product?.id) }}><FaPlus size={12} /></button>
                                            </div>
                                        </div>

                                        <div className="item-price">
                                            {item?.sku?.productPrice && (
                                                <span className="original-price">{priceFunction(Number(item?.sku?.productPrice) * Number(item?.quantity))}</span>
                                            )}
                                            <span className="discounted-price">{priceFunction(Number(item?.sku?.salePrice) * Number(item?.quantity))}</span>
                                            {/* <button className="remove-btn">Remove</button> */}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        )
                    }


                    {/* suugestion product */}
                    <div className="cart-suggested-section">
                        <h2 className="section-title">You May Also Like</h2>
                        <div className="product-list">
                            {suggestionitems?.map(product => {

                                return (
                                    <div className="single-product-card">
                                        {/* Image */}
                                        <img src={productImagePath(product?.productMainImage)} alt={product?.productName} className="product-image" />

                                        {/* Details */}
                                        <div className="product-info">
                                            <h3 className="product-title">{product?.productName}</h3>
                                            {/* <p className="product-subtitle">{product.subtitle}</p> */}

                                            <div className="sku-and-add">
                                                <div className="sku-button">
                                                    <select className="sku-select" onChange={(e) =>
                                                        handleSkuChange(product.id, e.target.value)
                                                    }
                                                    >
                                                        {product?.skus?.map((sku) => (
                                                            <option value={sku.id}>
                                                                {sku.skuName} - ₹{sku.salePrice}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {product?.skus?.length > 1 && <FaChevronDown className="chevron-icon" />}
                                                </div>

                                                <button className="circle-add-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const skuToUse =
                                                      selectedSkus[product.id] || product?.skus?.[0]?.id; // default first sku
                                                  
                                                    if (!skuToUse) {
                                                      swal('', "Please select one variant", "error");
                                                      return;
                                                    }
                                                  
                                                    onAddToCartClick(skuToUse, 1, product.id);
                                                  }}>
                                                    <FaPlus />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {((isLoggedIn && (apiCartData || []).length) || (!isLoggedIn && (localCartInfoState || []).length)) ?
                        <div class="button-group">
                            <div className="cart-summary-container">
                                <div className="cart-summary-header" onClick={() => setIsCartOpen(!isCartOpen)}>
                                    <h3>Your Cart <span>({isLoggedIn ? (cartCount) : (cartCountLocal)} items)</span></h3>
                                    <h3>
                                        Total {priceFunction(
                                            isLoggedIn
                                                ? productReducer?.cartDetails?.orderTotal
                                                : productReducer?.cartTotal
                                        )} {isCartOpen ? <FaChevronDown /> : <FaChevronUp />}
                                    </h3>
                                </div>

                                {isCartOpen && (
                                    <div className="cart-breakdown">
                                        <div className="row">
                                            <span>Subtotal</span>
                                            <span>{priceFunction(isLoggedIn ? productReducer?.cartDetails?.subTotal : productReducer?.cartSubTotal)}</span>
                                        </div>

                                        <div className="row">
                                            <span className="gradient-text">Coupon Discount</span>
                                            <span className="negative-amount">{priceFunction(isLoggedIn ? productReducer?.cartDetails?.discount : productReducer?.cartDiscount)}</span>
                                        </div>
                                        {productReducer?.cartDetails?.bundleDiscountValue > 0 &&
                                            <div className="row">
                                                <span className="gradient-text">Bundle Discount</span>
                                                <span className="save-amount">{priceFunction(productReducer?.cartDetails?.bundleDiscountValue)}</span>
                                            </div>
                                        }
                                        {productReducer?.cartDetails?.subscriptionDiscountValue > 0 &&
                                            <div className="row">
                                                <span className="gradient-text">Subscription Discount</span>
                                                <span className="save-amount">{priceFunction(productReducer?.cartDetails?.subscriptionDiscountValue)}</span>
                                            </div>
                                        }


                                        <div className="row">
                                            <span className="gradient-text">Delivery Charge</span>
                                            <span className="free-text">{
                                                isLoggedIn
                                                    ? productReducer?.cartDetails?.deliveryCharge == 0 ? "Free" : priceFunction(productReducer?.cartDetails?.deliveryCharge)
                                                    :
                                                    "Free"

                                            }</span>
                                        </div>
                                        <hr />
                                        <div className="row total-row">
                                            <strong>Order Total</strong>
                                            <strong>{priceFunction(
                                                isLoggedIn
                                                    ? productReducer?.cartDetails?.orderTotal
                                                    : productReducer?.cartTotal
                                            )}</strong>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <button class="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    history.push('/cart');
                                    setCartModel(false);
                                }}
                            >
                                VIEW FULL CART
                            </button>
                        </div>
                        :
                        <div class="button-group">
                            <button class="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    history.push('/product_list/prefill/all');
                                    setCartModel(false);
                                }}
                            >
                                CONTINUE SHOPPING
                            </button>
                        </div>
                    }


                </div>
            )}





        </>
    );
}

export default Header;
